import{useState as r}from"react";import{useRouter as t}from"next/navigation";var o=function(){var o=r(!1),e=o[0],n=o[1],a=t();return{loading:e,routerPush:function(r){n(!0),a.push(r)},routerReplace:function(r){n(!0),a.replace(r)},router:a}};export{o as default};
//# sourceMappingURL=index.js.map
